import { ProductImage } from '@scripts/frontend/features/products/components/ProductImage'
import { ImageSize } from '@scripts/frontend/libs/types/media'
import { formatPrice } from '@scripts/frontend/libs/utils/format-price'
import { Link } from 'react-router-dom'

import type { OrderItem as OrderItemType } from '../libs/type'

export type OrderProductItemProps = OrderItemType

export function OrderProductItem({
  image,
  name,
  permalink,
  price,
  productType,
  quantity,
  total,
  variationAttributes,
}: Readonly<OrderProductItemProps>) {
  return (
    <div className="border">
      <div className="grid divide-y divide-gray-200">
        <div className="flex gap-6 p-6 md:gap-10">
          <div className="w-28 border md:w-40">
            <Link to={permalink}>
              <ProductImage image={image} size={ImageSize.Thumbnail} />
            </Link>
          </div>
          <div className="relative w-full text-sm md:w-[calc(100%_-_10rem)]">
            <div className="flex justify-between gap-6">
              <div className="font-medium">
                <Link to={permalink}>{name}</Link>{' '}
                <strong className="">x&nbsp;{quantity}</strong>{' '}
              </div>
              <div className="font-medium">
                <span>{formatPrice(price)}</span>
              </div>
            </div>
            {productType === 'variation' && variationAttributes && (
              <div className="mt-4 grid gap-2">
                <div className="[&amp;>*:not(:first-child)]:pl-6 flex space-x-6 divide-x">
                  {variationAttributes.map((attribute) => (
                    <div className="flex gap-2 capitalize" key={attribute.name}>
                      <strong>{attribute.name}:</strong>{' '}
                      <p>{attribute.value}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderProductItem
